
namespace GeniuzPOS.LogManage {

    @Serenity.Decorators.registerClass()
    export class LogUserPasswordChangeDateDialog extends Serenity.EntityDialog<LogUserPasswordChangeDateRow, any> {
        protected getFormKey() { return LogUserPasswordChangeDateForm.formKey; }
        protected getIdProperty() { return LogUserPasswordChangeDateRow.idProperty; }
        protected getLocalTextPrefix() { return LogUserPasswordChangeDateRow.localTextPrefix; }
        protected getNameProperty() { return LogUserPasswordChangeDateRow.nameProperty; }
        protected getService() { return LogUserPasswordChangeDateService.baseUrl; }
        protected getDeletePermission() { return LogUserPasswordChangeDateRow.deletePermission; }
        protected getInsertPermission() { return LogUserPasswordChangeDateRow.insertPermission; }
        protected getUpdatePermission() { return LogUserPasswordChangeDateRow.updatePermission; }

        protected form = new LogUserPasswordChangeDateForm(this.idPrefix);

    }
}